import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ToastContext = createContext(null);

let _toastId = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const show = useCallback((message, { type = 'info', duration = 3000, icon } = {}) => {
    const id = ++_toastId;
    setToasts(prev => [...prev.slice(-3), { id, message, type, icon }]);
    if (duration > 0) setTimeout(() => dismiss(id), duration);
    return id;
  }, [dismiss]);

  // Convenience methods
  const toast = {
    show,
    success: (msg, opts) => show(msg, { type: 'success', icon: '✓', ...opts }),
    error:   (msg, opts) => show(msg, { type: 'error',   icon: '✕', duration: 5000, ...opts }),
    info:    (msg, opts) => show(msg, { type: 'info',    ...opts }),
    dismiss,
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className="toast-container" aria-live="polite">
        {toasts.map(t => (
          <div key={t.id} className={`toast toast-${t.type}`} onClick={() => dismiss(t.id)}>
            {t.icon && <span className="toast-icon">{t.icon}</span>}
            <span className="toast-msg">{t.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx;
}
